<template>
  <div class="columns">
    <div class="sideText"></div>

    <div class="container" >
      <div class="header"> 
        <div class="closeButton">
          <button class="btn theme-close-button" @click="home">
            <font-awesome-icon icon="times" />
          </button>
        </div>
        <h2>{{$t('signup.emailConfirmation')}}</h2>
      </div>
      <div class="fieldsContainer">
        <p>{{$t('signup.confirmationWaiting')}}</p>

        <div v-if="succesMessage">
          <p>{{succesMessage}}</p>
        </div>
        
        <div v-if="errorMessage" class="w3-panel errorBox w3-round">
          {{ errorMessage }} 
          <font-awesome-icon icon="exclamation-circle" class="errorIcon w3-right"/>
        </div>
      </div>
      
      <div class="buttonContainer">
        <div class="link">
          <br/>
          <router-link to="/resend-confirmation" class="specialLink w3-right" v-if="confirmationError">{{ $t('signin.confirmationNotReceived') }}</router-link>
        </div>
        <div class="flex"> 
          <button class="button-default" @click="signIn">{{$t('signup.toSignin')}}</button>
        </div>
      </div>  
    </div>
    <div class="dummySpace">&nbsp;</div>
    <div class="bottomLogo"><h4><img class="logo-c" :src="knightC" >hess Administrator</h4></div>
  </div>  
</template>

<script>
import {RestAPI} from "@aws-amplify/api-rest";

const apiName = 'api';
const path = '/Authentication/ConfirmEmail';
const myInit = { 
  response: false,
};

export default {
  name: 'EmailConfirmation',
  data: function () {
    return {
      confirmationError: false,
      errorMessage: "",
      succesMessage: ""
    }
  },
  mounted() {
    this.confirm();
  },
  methods: {
    confirm() {
      let that = this;
      let completePath = path + "?token="  + encodeURIComponent(this.$route.query.token) + "&email=" + this.$route.query.email;
      RestAPI
        .get(apiName, completePath, myInit)
        .then(response => {
          that.confirmationError = false;
          console.log(JSON.stringify(response.token));
          that.$router.push("/sign-in?ontheside=confirmationSucces");
          })
        .catch(error => {
          that.confirmationError = true;
          console.log("ERROR", JSON.stringify(error.response.data));
          switch(error.response.data.errorstring) {
            case "Confirmation failed":
              this.errorMessage = error.response.data.errorstring;
              break;
            case "Invalid token":
              this.errorMessage = error.response.data.errorstring;
              break;
            default:
              this.errorMessage = error.response.data.errorstring;
        }
      });
    },
    home() {
      this.$router.push("/");
    },
    signIn() {
      this.$router.push("/sign-in");
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.container {
  margin-top: 10vh;
}

.errorIcon {
  margin-top: 4px; 
}

/* mobile */
@media screen and (max-width: 600px) {
  .columns {
    display: flex;
    flex-direction: column;
    width: 90vw;
  }

  .container {
    width: 90vw;
  }
}

/* ipad */
@media screen and (min-width: 601px) and (max-width: 1280px) {
  .columns {
    display: flex;
    flex-direction: column;
    width: 300px;
  }

  .container {
    width: 300px;
  }

  .sideText {
    width: 300px;
    margin-top: 12vh;
  }
}

/* laptop */
@media screen and (min-width: 1281px) {
  .columns {
    display: flex;
    flex-direction: row;
    margin: auto;
  }

  .dummySpace {
    width: 350px;
  }

  .sideText {
    width: 350px;
    margin-top: 12vh;
  }

  .container {
    width: 300px;
  }
}

</style>
